import { useContext } from "react";
import { RetailOrderContext } from "../context/RetailOrderContext";
import { confirm } from 'devextreme/ui/dialog';
import { useHaltCustomerNotifications } from "../api/halt-customer-notifications";
import { showErrorMessage } from "../../../../utils/messages";
import { useGetCurrentUserInformation } from "../../../../api/current-user";

export default function CustomerNotificationsStatus() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const currentUser = useGetCurrentUserInformation();

	const haltCustomerNotifications = useHaltCustomerNotifications(order.details.retailOrderID,
		() => {
			refetchOrder();
		},
		(error) => {
			showErrorMessage(error);
		});

	return (
		<>
			{
				order.details.customerNotificationsHalted ?
					<span style={{ color: "red" }}>Halted</span> :
					<>
						<span style={{ color: "green" }}>Active</span>
						{
							currentUser.data?.groups.includes("Project Manager") &&
							<a href="" onClick={(e) => {
								e.preventDefault();
								var result = confirm("Are you sure you want to halt all customer notifications for this order? This cannot be undone.", "Customer Notifications");
								result.then((dialogResult) => {
									if (dialogResult) {
										haltCustomerNotifications.mutate();
									}
								});

							}}>Halt the notifications</a>
						}
					</>
			}
		</>
	)
}